
export default function Studio() {
  const features = [
    {
      icon: 'ri-mic-2-line',
      title: 'Grabación Profesional',
      description: 'Cabinas acústicas de última generación con equipos de grabación de alta fidelidad para capturar cada detalle de tu música.'
    },
    {
      icon: 'ri-equalizer-line',
      title: 'Mezcla y Masterización',
      description: 'Ingenieros de sonido certificados que trabajan con software profesional para lograr el mejor balance y calidad sonora.'
    },
    {
      icon: 'ri-headphone-line',
      title: 'Producción Musical',
      description: 'Servicio completo de producción musical desde la pre-producción hasta el producto final listo para distribución.'
    },
    {
      icon: 'ri-music-2-line',
      title: 'Composición y Arreglos',
      description: 'Equipo creativo que te ayuda con composición, arreglos musicales y adaptaciones para diferentes géneros.'
    }
  ];

  const equipment = [
    {
      icon: 'ri-speaker-3-line',
      title: 'Sistemas de Sonido',
      items: ['Line Array profesional', 'Monitores de escenario', 'Subwoofers de alta potencia', 'Amplificadores digitales']
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Iluminación Escénica',
      items: ['Moving heads LED', 'Luces robóticas', 'Efectos especiales', 'Control DMX profesional']
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Equipo Técnico',
      items: ['Consolas digitales', 'Procesadores de audio', 'Micrófonos profesionales', 'Sistemas inalámbricos']
    }
  ];

  return (
    <section id="estudio" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Montserrat',sans-serif] text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Estudio y Renta de Sonido
          </h2>
          <p className="font-['Poppins',sans-serif] text-base text-gray-600 max-w-2xl mx-auto">
            Tecnología de punta y equipos profesionales para llevar tu música y eventos al siguiente nivel
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
          <div>
            <h3 className="font-['Montserrat',sans-serif] text-3xl font-bold text-gray-900 mb-8">
              Estudio de Grabación
            </h3>
            <div className="space-y-6">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl shadow-lg">
                    <i className={`${feature.icon} text-2xl text-white w-6 h-6 flex items-center justify-center`}></i>
                  </div>
                  <div>
                    <h4 className="font-['Montserrat',sans-serif] text-lg font-bold text-gray-900 mb-2">
                      {feature.title}
                    </h4>
                    <p className="font-['Poppins',sans-serif] text-sm text-gray-600 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative w-full h-96 lg:h-auto rounded-2xl overflow-hidden shadow-2xl">
            <img 
              src="https://public.readdy.ai/ai/img_res/b56d9f875707e8a162d51cce714575d9.jpg"
              alt="Estudio de Grabación"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 md:p-12 shadow-xl">
          <h3 className="font-['Montserrat',sans-serif] text-3xl font-bold text-gray-900 mb-12 text-center">
            Renta de Equipo Profesional
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {equipment.map((category, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-lg">
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl mb-6 shadow-lg">
                  <i className={`${category.icon} text-2xl text-white w-7 h-7 flex items-center justify-center`}></i>
                </div>
                <h4 className="font-['Montserrat',sans-serif] text-xl font-bold text-gray-900 mb-4">
                  {category.title}
                </h4>
                <ul className="space-y-3">
                  {category.items.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <i className="ri-check-line text-teal-600 text-lg mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                      <span className="font-['Poppins',sans-serif] text-sm text-gray-600">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="font-['Poppins',sans-serif] text-base text-gray-700 mb-6">
              Contamos con técnicos especializados que se encargan de la instalación, operación y desmontaje de todo el equipo
            </p>
            <button 
              onClick={() => {
                const element = document.getElementById('contacto');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-gradient-to-r from-teal-600 to-teal-500 text-white px-8 py-3 rounded-full text-base font-semibold hover:from-teal-700 hover:to-teal-600 transition-all shadow-lg whitespace-nowrap cursor-pointer inline-block"
            >
              Solicitar Cotización
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
